import { apiFetch } from "./client";
import type { ApiResponse } from "@/types/api";

export interface Usuario {
  id: number;
  email: string;
  nombre: string;
  activo: boolean;
  created_at: string;
  rol_id?: number;
  rol_nombre?: string;
}

export interface Rol {
  id: number;
  nombre: string;
  descripcion?: string;
}

export interface Permiso {
  id: number;
  nombre: string;
  descripcion: string;
}

export interface CreateUsuarioRequest {
  email: string;
  nombre: string;
  password: string;
  rol_id: number;
}

export interface UpdateUsuarioRequest {
  email?: string;
  nombre?: string;
  password?: string;
  rol_id?: number;
  activo?: number;
}

export interface PermisosUpdateRequest {
  permisos_ids: number[];
}

export const listUsuarios = (
  params: { page?: number; limit?: number; q?: string } = {},
) =>
  apiFetch<ApiResponse<Usuario[]> & {
    pagination?: { page: number; limit: number; total: number; total_pages: number };
  }>("/api/v1/usuarios", {
    params: { _t: Date.now(), ...params },
    cache: "no-store",
    headers: {
      "Cache-Control": "no-cache",
      Pragma: "no-cache",
    },
  }).then((res) => ({
    data: res.data ?? [],
    pagination: res.pagination,
  }));

export const getUsuario = (id: number) =>
  apiFetch<ApiResponse<Usuario>>(`/api/v1/usuarios/${id}`).then(
    (res) => res.data as Usuario,
  );

export const createUsuario = (body: CreateUsuarioRequest) =>
  apiFetch<ApiResponse<null>>("/api/v1/usuarios", {
    method: "POST",
    body: JSON.stringify(body),
  });

export const updateUsuario = (id: number, body: UpdateUsuarioRequest) =>
  apiFetch<ApiResponse<null>>(`/api/v1/usuarios/${id}`, {
    method: "PUT",
    body: JSON.stringify(body),
  });

export const deleteUsuario = (id: number) =>
  apiFetch<ApiResponse<null>>(`/api/v1/usuarios/${id}`, {
    method: "DELETE",
  });

export const listRoles = () =>
  apiFetch<ApiResponse<Rol[]>>("/api/v1/roles").then((res) => res.data ?? []);

export interface CreateRolRequest {
  nombre: string;
  descripcion?: string;
}

export const createRol = (body: CreateRolRequest) =>
  apiFetch<ApiResponse<null>>("/api/v1/roles", {
    method: "POST",
    body: JSON.stringify(body),
  });

export const getPermisosDeRol = (id: number) =>
  apiFetch<ApiResponse<number[]>>(`/api/v1/roles/${id}/permisos`).then(
    (res) => res.data ?? [],
  );

export const updatePermisosDeRol = (id: number, permisos_ids: number[]) =>
  apiFetch<ApiResponse<null>>(`/api/v1/roles/${id}/permisos`, {
    method: "PUT",
    body: JSON.stringify({ permisos_ids }),
  });

export const listPermisos = () =>
  apiFetch<ApiResponse<Permiso[]>>("/api/v1/permisos").then(
    (res) => res.data ?? [],
  );

export const getPermisosDeUsuario = (id: number) =>
  apiFetch<ApiResponse<number[]>>(`/api/v1/usuarios/${id}/permisos`).then(
    (res) => res.data ?? [],
  );

export const updatePermisosDeUsuario = (id: number, permisos_ids: number[]) =>
  apiFetch<ApiResponse<null>>(`/api/v1/usuarios/${id}/permisos`, {
    method: "PUT",
    body: JSON.stringify({ permisos_ids }),
  });
